module.exports = __webpack_public_path__ + "img/naturalAce.3d8466a5.jpeg";